import { call, put, takeLatest } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';
import { DELETE_INVENTORY_STOCK_LINE_SUCCESS } from 'redux/modules/inventoryStockLine';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const FETCH_INVENTORY_STOCK_LINE_HISTORY = 'FETCH_INVENTORY_STOCK_LINE_HISTORY';
export const FETCH_INVENTORY_STOCK_LINE_HISTORY_SUCCESS = 'FETCH_INVENTORY_STOCK_LINE_HISTORY_SUCCESS';
export const FETCH_INVENTORY_STOCK_LINE_HISTORY_FAIL = 'FETCH_INVENTORY_STOCK_LINE_HISTORY_FAIL';
export const CLEAR_INVENTORY_STOCK_LINE_HISTORY = 'CLEAR_INVENTORY_STOCK_LINE_HISTORY';

// Reducer
export default function inventoryStockLineHistoryReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_INVENTORY_STOCK_LINE_HISTORY:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_INVENTORY_STOCK_LINE_HISTORY_SUCCESS: {
      if (payload.push) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ];
        return {
          ...state,
          count: payload.count,
          data: newData,
          ...triggerLoading ? { loading: state.loading - 1 } : {},
        };
      }
      return {
        ...state,
        ...payload,
        data: payload.data.reverse().reduce((accumulator, currentValue) => {
          if (currentValue['Stock Line ID']) {
            const parentStockLineIndex = accumulator.findIndex(item =>
              item.ID === currentValue['Stock Line ID']);
            // const subTotal = accumulator
            return [
              ...accumulator.slice(0, parentStockLineIndex),
              currentValue,
              ...accumulator.slice(parentStockLineIndex),
            ];
          }
          return [
            ...accumulator,
            currentValue,
          ];
        }, []).reverse(),
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_INVENTORY_STOCK_LINE_HISTORY_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_INVENTORY_STOCK_LINE_HISTORY:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case DELETE_INVENTORY_STOCK_LINE_SUCCESS: {
      const index = state.data.findIndex(dataItem => dataItem.ID === payload.ID);
      const newData = [
        ...state.data.slice(0, index),
        ...state.data.slice(index + 1),
      ];
      return {
        ...state,
        count: state.count - 1,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchInventoryStockLineHistory(payload) {
  return { type: FETCH_INVENTORY_STOCK_LINE_HISTORY, payload };
}

export function fetchInventoryStockLineHistorySuccess(payload) {
  return { type: FETCH_INVENTORY_STOCK_LINE_HISTORY_SUCCESS, payload };
}

export function fetchInventoryStockLineHistoryFail(payload) {
  return { type: FETCH_INVENTORY_STOCK_LINE_HISTORY_FAIL, payload };
}

export function clearInventoryStockLineHistory(payload) {
  return { type: CLEAR_INVENTORY_STOCK_LINE_HISTORY, payload };
}

// Requests
export function requestSearchInventoryStockLineHistory({ filters }) {
  return callApi('inventory/stock_history/search/', 'POST', { filters });
}

// Sagas
function* fetchInventoryStockLineHistorySaga(action) {
  const { triggerLoading, push } = action.payload;
  try {
    const res = yield call(requestSearchInventoryStockLineHistory, action.payload);
    if (res.count === 0) {
      yield put(fetchInventoryStockLineHistorySuccess({
        data: res.data,
        count: res.count,
        triggerLoading,
      }));
    } else if (push) {
      yield put(fetchInventoryStockLineHistorySuccess({
        push: true,
        data: res.data,
        count: res.count,
        triggerLoading,
      }));
    } else {
      yield put(fetchInventoryStockLineHistorySuccess({
        data: res.data,
        count: res.count,
        triggerLoading,
      }));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchInventoryStockLineHistoryFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

export function* inventoryStockLineHistorySaga() {
  yield takeLatest(FETCH_INVENTORY_STOCK_LINE_HISTORY, fetchInventoryStockLineHistorySaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/inventoryStockLineHistory.js